import apiClient from './api';

// A real, dignified fallback asset (calm card silhouette on cream). NEVER a broken-image icon —
// this is grief-adjacent. Lives in store/public so CRA serves it at this path.
export const CARD_PLACEHOLDER_SRC = '/images/card-placeholder.svg';

// Where the backend lives. Mirrors the axios client so dev/prod resolve identically.
export function getApiBase() {
  return apiClient?.client?.defaults?.baseURL || 'http://localhost:8000';
}

/**
 * Single source of truth for a card-cover image URL. Defaults to the WebP `preview` derivative — the
 * format the store serves EVERYWHERE for covers. Pass a different `size` only for an intentional
 * full-res view (e.g. a zoom). Returns null when the cover image id is missing so callers render the
 * placeholder instead of firing a broken request.
 */
export function getCardCoverUrl(cardId, imageId, size = 'preview') {
  if (!cardId || !imageId) return null;
  return `${getApiBase()}/api/cards/${cardId}/images/${imageId}/${size}`;
}
